module.exports = __webpack_public_path__ + "img/logo-doha.124aca94.png";